import { render, staticRenderFns } from "./details.vue?vue&type=template&id=77a63bca&scoped=true"
import script from "./details.vue?vue&type=script&lang=js"
export * from "./details.vue?vue&type=script&lang=js"
import style0 from "./details.vue?vue&type=style&index=0&id=77a63bca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a63bca",
  null
  
)

export default component.exports